import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {

  enableChatbot: boolean = false;
  constructor() { 
    this.enableChatbot = environment.showChatbot;
  }

  ngOnInit(): void {
  }

}
